import { useCallback, useRef, useState } from 'react';
import { IVolunteerShift } from '../../../../../../queries/Volunteer';
import { ShiftDataSource } from '../../../../../pages/Volunteers/shiftDataSource';

export function useDraftShiftDataSource(): ShiftDataSource {
	const [shifts, setShifts] = useState<IVolunteerShift[]>([]);
	const seq = useRef(0);

	const createShifts = useCallback(async (bodies: Partial<IVolunteerShift>[]) => {
		const created = bodies.map(body => ({ ...body, id: `draft-${seq.current++}` }) as IVolunteerShift);
		setShifts(prev => [...prev, ...created]);
		return { created: created.length, failed: 0, succeeded: bodies };
	}, []);

	const updateShift = useCallback(async (shift: IVolunteerShift) => {
		setShifts(prev => prev.map(s => (s.id === shift.id ? shift : s)));
	}, []);

	const archiveShift = useCallback(async (shiftId: string) => {
		setShifts(prev => prev.filter(s => s.id !== shiftId));
	}, []);

	return { shifts, isLoading: false, createShifts, updateShift, archiveShift };
}
